import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { TestimonialCardProps } from "@/models/ITestimonial";

const TestimonialCard = ({ comment }: TestimonialCardProps) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsTruncated(element.scrollHeight > element.clientHeight);
    }
  }, [comment.Comment1]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const tooltipElement = document.querySelector(".tooltip-content");

      if (
        textRef.current &&
        !textRef.current.contains(target) &&
        tooltipElement &&
        !tooltipElement.contains(target)
      ) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handleTogglePopup = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isTruncated) {
      setIsPopupOpen(!isPopupOpen);
    }
  };
  return (
    <div className="border shadow-[4px_4px_0px_0px_#fbcfc8] bg-bg-neutral_rose_tint border-border-gray90 rounded-xl px-6 py-6 flex flex-col justify-between h-fit">
      {/* <p className="text-base leading-6 mb-6 line-clamp-6">
        {comment.Comment1}
      </p> */}
      <div className="relative group mb-6">
        <p
          ref={textRef}
          className={`line-clamp-6 text-base leading-normal font-normal ${isTruncated ? "cursor-pointer active:opacity-70" : ""}`}
          onClick={handleTogglePopup}
        >
          {comment.Comment1}
        </p>

        {isTruncated && (
          <div
            className={`tooltip-content absolute left-0 top-full mt-2 w-[calc(100vw-2rem)] sm:w-auto sm:max-w-md md:max-w-md bg-white border border-gray-300 rounded-lg shadow-lg p-4 z-10 ${isPopupOpen ? "block md:hidden" : "hidden"} md:group-hover:block`}
          >
            <p className="text-base leading-6">{comment.Comment1}</p>
          </div>
        )}
      </div>
      {/* Author */}
      <div className="flex flex-col gap-4">
        <div className="text-xl leading-normal font-semibold">
          {comment.BiotechName}
        </div>
        <div className="flex items-center gap-3">
          {comment.Image?.url && (
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}${comment.Image.url}`}
              alt={comment.Image?.alternativeText || "Testimonial"}
              className="h-12 w-12 rounded-lg object-cover"
            />
          )}

          <div>
            <div className="text-base leading-normal font-semibold text-[#465158]">
              {comment.Name}
            </div>
            <div className="line-clamp-2 text-base leading-normal font-normal text-[#465158]">
              {comment.Designation}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
